import * as moment from "moment";
import missionApi from "@/api/missionApi";

export const MISSION_ONGOING = "ONGOING";
export const MISSION_SCHEDULED = "SCHEDULED";
export const MISSION_ENDED = "ENDED";

export default class Mission {
  advertiserName = "";
  gameName = null;
  name = "";
  codeName = "";
  startAt = "";
  endAt = "";
  customerSupportName = "";
  customerSupportUrl = "";
  agitUrl = "";
  missionDescription = "";
  extraInfo = {
    kakaoRewardApiKey: ""
  };
  totalPurchaseAmount = 0;
  rewardUnitPrice = 0;

  rewardType = "KAKAO_EMOTICON";
  adAccount = 1;
  appId = 1;

  /***
   * 사용자 표시용 상태 정보 (진행중 종료 예정)
   * @type {string}
   */
  detailStatus = "";

  /***
   * 리포트 정보
   */
  report = null;

  constructor(missionDto) {
    if (missionDto) {
      for (const key of Object.keys(missionDto)) {
        this[key] = missionDto[key];
      }

      this.startAt = this.startAt.kstToLtz();
      this.endAt = this.endAt.kstToLtz();

      const now = moment().unix();
      const startAtDate = this.startAt.unixTime();
      const endAtDate = this.endAt.unixTime();
      if (startAtDate <= now && now <= endAtDate) {
        this.detailStatus = MISSION_ONGOING;
      } else if (now < startAtDate) {
        this.detailStatus = MISSION_SCHEDULED;
      } else {
        this.detailStatus = MISSION_ENDED;
      }
    }
  }

  convertToDto() {
    const dto = JSON.parse(JSON.stringify(this));

    dto.startAt = moment(dto.startAt).hour(14).minute(0).second(0).format("YYYY-MM-DD HH:mm:ss");
    dto.endAt = moment(dto.endAt).hour(13).minute(59).second(59).format("YYYY-MM-DD HH:mm:ss");
    dto.startAt = dto.startAt.ltzToKst();
    dto.endAt = dto.endAt.ltzToKst();

    return dto;
  }

  isOnGoing() {
    return this.detailStatus === MISSION_ONGOING;
  }

  isScheduled() {
    return this.detailStatus === MISSION_SCHEDULED;
  }

  isEnded() {
    return this.detailStatus === MISSION_ENDED;
  }

  loadReport() {
    if (this.id !== undefined && this.report === null) {
      missionApi.getMissionReportByMissionId(this.id)
        .then(
          response => {
            this.report = response?.data?.data?.report;
          }
        );
    }
  }
}
